import script from "./AtomInputMoney.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomInputMoney.vue?vue&type=script&lang=ts&setup=true"

import "./AtomInputMoney.vue?vue&type=style&index=0&id=730ba270&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-730ba270"]])

export default __exports__